import Vue from 'vue';
const STORAGE_KEY = 'xy_pinned_group_projects';
const buildKey = (groupId, projectId) => `${groupId}*${projectId}`;
const loadFromStorage = () => {
    try {
        const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
            const result = {};
            Object.keys(raw).forEach((k) => {
                if (raw[k])
                    result[k] = true;
            });
            return result;
        }
        return {};
    }
    catch {
        return {};
    }
};
const persist = (state) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(state.groupProjectPinned));
    }
    catch {
        // ignore quota / privacy mode
    }
};
export default {
    state: () => ({
        groupProjectPinned: loadFromStorage(),
    }),
    getters: {
        isGroupProjectPinned: (state) => (groupId, projectId) => Boolean(state.groupProjectPinned[buildKey(groupId, projectId)]),
    },
    mutations: {
        setGroupProjectPin(state, { groupId, projectId }) {
            Vue.set(state.groupProjectPinned, buildKey(groupId, projectId), true);
            persist(state);
        },
        unsetGroupProjectPin(state, { groupId, projectId }) {
            Vue.delete(state.groupProjectPinned, buildKey(groupId, projectId));
            persist(state);
        },
    },
    actions: {
        toggleGroupProjectPin({ state, commit }, payload) {
            if (state.groupProjectPinned[buildKey(payload.groupId, payload.projectId)]) {
                commit('unsetGroupProjectPin', payload);
            }
            else {
                commit('setGroupProjectPin', payload);
            }
        },
    },
};
